enum SelectedNavBarTile {
  HOME = 'home',
  QUEUE = 'queue',
  SEARCH = 'search',
  LIBRARY = 'library'
}

export default SelectedNavBarTile
